import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DailyCheckInMutationKeys } from '../../../keys'
import {
	CreateDailyCheckInRequest,
	CreateDailyCheckInResponse,
} from '../../../type'
import { createDailyCheckIn } from '../../services'

interface CreateDailyCheckInParams {
	payload: CreateDailyCheckInRequest
}

export default function useMutationCreateDailyCheckIn(
	props?: UseBaseMutationOptions<
		CreateDailyCheckInResponse,
		CreateDailyCheckInParams
	>,
) {
	return useMutation({
		mutationKey: [DailyCheckInMutationKeys.CreateDailyCheckIn],
		mutationFn: (params) => createDailyCheckIn(params.payload),
		...props,
	})
}
